module.exports = __webpack_public_path__ + "static/media/rujuta-kumbhare.69a13317.png";